import type { IconSvgObject } from './types';

const WifiLocationIcon: IconSvgObject = [
  ["path", { d: "M21 11.0891C21 16.8654 14.9912 20.619 12.7931 21.7988C12.2934 22.0671 11.7066 22.0671 11.2069 21.7988C9.00877 20.619 3 16.8654 3 11.0891C3 6.06935 7.02944 2 12 2C16.9706 2 21 6.06935 21 11.0891Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 12.8647C10.2106 12.2981 11.0929 11.9904 12.0018 11.9922C12.9106 11.994 13.7917 12.3053 14.5 12.8747M12 16H12.01M7 9.755C8.4189 8.61897 10.1824 8 12 8C13.8176 8 15.5811 8.61897 17 9.755", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WifiLocationIcon;
